/**
 * Created by Ning Jiang on 2022-05-02.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Layers, SerialLayers} from "../../../view/SerialLayers";
import {Serial} from "../../../Serial";
import {gsap} from "gsap";

export class WinEffect extends PIXI.Container {

    public winLevel:number;
    public symHeight:number;
    private _animation:PIXI.spine.Spine;

    constructor(symHeight:number, level:number) {
        super();

        this.winLevel = level;
        this.symHeight = symHeight;

        this._animation = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("initialWin"));
        this._animation.autoUpdate = true;
        this.addChild(this._animation);
    }

    private getAnimationName():string {
        const size = this.getSize();
        switch(this.winLevel) {
            case 2:
                return `M${size}`;
            case 3:
                return `L${size}`;
            default:
                return `S${size}`;
        }
    }

    private getSize():string {
        if(this.symHeight > 150) {
            return `156`;
        }
        if(this.symHeight > 100) {
            return `104`;
        }
        return `78`;
    }

    public playOnce(layer:StageLayer):gsap.core.Timeline {
        const animationName = this.getAnimationName();
        const tl = gsap.timeline();
        tl.add(() => {
            layer.addChild(this);
            this._animation.state.setAnimation(0, animationName, false);
        });
        tl.add(() => {
            this._animation.state.clearTrack(0);
            this._animation.skeleton.setToSetupPose();
            this._animation.state.setEmptyAnimation(0, 0);
            layer.removeChild(this);
            this.destroy();
        }, this._animation.spineData.findAnimation(animationName).duration);

        return tl;
    }
}

export class InitialWinView {

    private _layer:StageLayer;

    constructor() {
        this._layer = SerialLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
    }

    public playAnimation(symHeight:number, position:PIXI.Point, winLevel:number):gsap.core.Timeline {
        const effect = new WinEffect(symHeight, winLevel);
        effect.position.set(position.x, position.y);

        return effect.playOnce(this._layer);
    }


}